'use client';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import Link from 'next/link';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#f8f9fa',
        borderTop: '1px solid rgba(21,60,127,0.1)',
        py: 4,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: 3
          }}
        >
          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              fontSize: '0.9rem',
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            © Copyright {currentYear} - CareAscendium, LLC
          </Typography>

          {/* Legal Links */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 1, sm: 2 },
              alignItems: 'center'
            }}
          >
            <Link href="/privacy-policy" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#333',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  '&:hover': {
                    color: '#153C7F'
                  },
                  transition: 'color 0.2s ease'
                }}
              >
                Privacy Policy
              </Typography>
            </Link>
            <Box
              sx={{
                display: { xs: 'none', sm: 'block' },
                width: '1px',
                height: '16px',
                bgcolor: '#ddd'
              }}
            />
            <Link href="/terms-and-conditions" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#333',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  '&:hover': {
                    color: '#153C7F'
                  },
                  transition: 'color 0.2s ease'
                }}
              >
                Terms & Conditions
              </Typography>
            </Link>
            <Box
              sx={{
                display: { xs: 'none', sm: 'block' },
                width: '1px',
                height: '16px',
                bgcolor: '#ddd'
              }}
            />
            <Link href="/cookie-policy" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body2"
                sx={{
                  color: '#333',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  '&:hover': {
                    color: '#153C7F'
                  },
                  transition: 'color 0.2s ease'
                }}
              >
                Cookie Policy
              </Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

